export interface GuideVideoResource {
  url: string;
  label: string;
}

/** 使用说明视频资源，后续可按同样格式继续追加。 */
export const GUIDE_VIDEO_RESOURCES: GuideVideoResource[] = [
  {
    url: `${import.meta.env.VITE_FILE_SERVER_URL}/files/uploads/guides/product-demo.mp4`,
    label: '操作演示',
  },
  {
    url: `${import.meta.env.VITE_FILE_SERVER_URL}/files/uploads/guides/product-intro.mp4`,
    label: '产品介绍',
  },
];
